// extracted by mini-css-extract-plugin
export default {"loader-container":"CommonLoader_loader-container__K1D8K","mobile-loader-container":"CommonLoader_mobile-loader-container__9tkrs"};